// Truncation sx + accessible label helpers for TagChip (max-width ellipsis).

export const TAG_CHIP_PROJECT_DOT_SIZE_DENSE_PX = 8;
export const TAG_CHIP_PROJECT_DOT_SIZE_PX = 10;

export function tagChipProjectDotPx(dense) {
  return dense
    ? TAG_CHIP_PROJECT_DOT_SIZE_DENSE_PX
    : TAG_CHIP_PROJECT_DOT_SIZE_PX;
}

export const tagChipDenseSx = {
  height: 16,
  fontSize: '0.65rem',
  '& .MuiChip-label': { px: 0.75 },
};

function nameMaxWidthCh(dense) {
  return dense ? '14ch' : '16ch';
}

export function buildTagChipTruncateSx(
  dense,
  hasLabelSuffix,
  truncateToContainer = false,
) {
  const nameMax = nameMaxWidthCh(dense);
  if (hasLabelSuffix) {
    return {
      maxWidth: '100%',
      minWidth: 0,
      flexShrink: 1,
      '& .MuiChip-label': {
        display: 'inline-flex',
        alignItems: 'center',
        minWidth: 0,
        overflow: 'visible',
      },
    };
  }
  if (truncateToContainer) {
    return {
      maxWidth: '100%',
      minWidth: 0,
      flexShrink: 1,
      '& .MuiChip-label': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    };
  }
  return {
    maxWidth: `min(${nameMax}, 100%)`,
    minWidth: 0,
    flexShrink: 1,
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
}

export function resolveTagChipAccessibleLabel(
  prefixedLabel,
  ariaLabel,
  labelSuffix,
) {
  if (ariaLabel) return ariaLabel;
  if (labelSuffix) return `${prefixedLabel}${labelSuffix}`;
  return prefixedLabel;
}

export function tagChipNameMaxWidthCh(dense) {
  return nameMaxWidthCh(dense);
}

/** List-row project pills: tiers replace ch-based ellipsis truncation. */
export function buildTagChipListRowProjectSx(dense, tier) {
  if (tier === 'dot') {
    const dotPx = tagChipProjectDotPx(dense);
    const pad = dense ? 3 : 4;
    return {
      maxWidth: 'none',
      minWidth: dotPx + pad * 2,
      width: dotPx + pad * 2,
      flexShrink: 0,
      '& .MuiChip-label': {
        px: `${pad}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
      },
    };
  }
  return {
    maxWidth: 'none',
    minWidth: 0,
    flexShrink: 0,
    '& .MuiChip-label': {
      overflow: 'visible',
      textOverflow: 'clip',
      whiteSpace: 'nowrap',
    },
  };
}
